import { Injectable, inject } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor
} from '@angular/common/http';
import { EMPTY, Observable, switchMap } from 'rxjs';
import { SeguridadService } from '../modules/sistema/services/seguridad/seguridad.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    private _seguridadService = inject(SeguridadService);

    private apiUrl: string;

    /** Inserted by Angular inject() migration for backwards compatibility */
    constructor(...args: unknown[]);

    constructor() {
        this.apiUrl = inject<string>('BASE_URL' as any);
    }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        const target = new URL(request.url, window.location.origin);
        const reportOrigin = environment.servidorReportesUrl ? new URL(environment.servidorReportesUrl).origin : null;
        const requestForApis = target.pathname.startsWith('/api/') &&
            (target.origin === window.location.origin || target.origin === reportOrigin);

        const esEndpointDeRefresh = request.url.toLowerCase().includes('seguridad/refreshtoken');
        if (!requestForApis || esEndpointDeRefresh) {
            return next.handle(request);
        }

        const token = this._seguridadService.obtenerAccessToken();
        if (!token) {
            return next.handle(request);
        }

        if (this._seguridadService.esUsuarioImpersonado() && !this._seguridadService.esSesionActiva()) {
            this._seguridadService.regresarAlUsuarioOriginal();
            return EMPTY;
        }

        if (this._seguridadService.tokenExpiraProximamente()) {
            return this._seguridadService.refrescarTokenSiNecesario().pipe(
                switchMap(nuevoToken => {
                    const req = nuevoToken
                        ? request.clone({ headers: request.headers.set('Authorization', `Bearer ${nuevoToken}`) })
                        : request;
                    return next.handle(req);
                })
            );
        }

        return next.handle(request.clone({
            headers: request.headers.set('Authorization', `Bearer ${token}`)
        }));
    }
}
